module.exports = __webpack_public_path__ + "img/20190821145226117.89af77a5.png";